import { createSelector } from '@opengov/compose-app/reselect';
import { BasicColumnTypes } from '@opengov/ogql-types';
import {
  EOgqlAggregateColumnOperators,
  EReportColumnTypes,
  IReportColumn
} from '@opengov/reporting-types/src/reportColumns-immer';
import { ReportControlType } from '@opengov/reporting-types';

import { selectCurrentReportConfiguration, selectHiddenControls } from '../../common/reportConfiguration/selectors';

import { selectDetailTableColumns, selectHiddenColumnsFromDataMgr } from './selectReportExplorerState';

export const selectCategorizedByColumn = createSelector(
  selectCurrentReportConfiguration,
  (reportConfig) => reportConfig && reportConfig.visualizationQuery.categorizedByColumn
);
export const selectIsCategorizedByNone = createSelector(
  selectCategorizedByColumn,
  (col) =>
    col &&
    col.columnType === EReportColumnTypes.aggregate &&
    col.name === EOgqlAggregateColumnOperators.sum &&
    col.aggregateType === EOgqlAggregateColumnOperators.sum
);

const isTaggedHidden = (column: IReportColumn) => column.metadata?.tags.hidden === true;

export const selectCategorizedByOptions = createSelector(
  selectDetailTableColumns,
  selectHiddenControls,
  selectCategorizedByColumn,
  selectHiddenColumnsFromDataMgr,
  (columns: IReportColumn[], hiddenControls, categorizedByColumn, hiddenColsFromDataMgr): IReportColumn[] => {
    return columns
      ?.filter(
        (c) =>
          (c.type === BasicColumnTypes.Text || c.type === BasicColumnTypes.Boolean) &&
          (!(hiddenColsFromDataMgr.includes(c.name) || isTaggedHidden(c)) || categorizedByColumn.name === c.name)
      )
      .filter(
        (c) =>
          !(
            c.name !== categorizedByColumn.name &&
            hiddenControls.find((h) => h.columnName === c.name && h.type === ReportControlType.Categorize) !== undefined
          )
      )
      .sort((a, b) => a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()));
  }
);
